import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	Wrapper,
	Collection,
	TitleRow,
	AllLink,
	Next,
	Prev,
	GiftsWrapper as LinksWrapper,
	Gifts as Links,
} from '../Collections/collectionsStyles';
import CaretRight from 'core/icons/CaretRight';
import { ScrollWatch } from 'core/hoc';
import { scrollHandler } from '../../tools';
import Box from './Box';
import { Title, Divider } from 'listing/layout';
import { ResponsiveCheck } from 'core/providers/Responsive';

class VipCollection extends PureComponent {
	render () {
		const { name, url, boxes, storeSoldOut } = this.props;
		return boxes && boxes.length ? (
			<ResponsiveCheck>{({ isDesktop }) => (
				<Collection>
					<TitleRow>
						<Title>{ name }</Title>
						{url && (
							<AllLink href={url} title={`See All ${name}`}>
								<span>See All</span>
								<CaretRight fill="currentColor" />
							</AllLink>
						)}
					</TitleRow>

					<ScrollWatch>
						{({ wrapperRef, doneScrollingX, noScrollXYet }) => (
							<Wrapper>
								{isDesktop && !noScrollXYet && (
									<Prev onClick={scrollHandler(wrapperRef, true)} vip>
										<CaretRight fill="currentColor" />
									</Prev>
								)}
								<LinksWrapper doneScrollingX={doneScrollingX} noScrollYet={ !noScrollXYet }>
									<Links ref={wrapperRef}>
										{boxes.map((box, id) => (
											<Box key={id} {...box} soldOut={storeSoldOut}/>
										))}
									</Links>
								</LinksWrapper>
								{isDesktop && !doneScrollingX && (
									<Next onClick={scrollHandler(wrapperRef)} vip>
										<CaretRight fill="currentColor" />
									</Next>
								)}
							</Wrapper>
						)}
					</ScrollWatch>
					<Divider />
				</Collection>
			)}</ResponsiveCheck>
		) : null;
	}

	static propTypes = {
		name: PropTypes.string,
		url: PropTypes.string,
		boxes: PropTypes.arrayOf(PropTypes.shape({
			name: PropTypes.string,
			slug: PropTypes.string,
			img: PropTypes.string,
			stars: PropTypes.number,
			description: PropTypes.string,
			startingPrice: PropTypes.number,
			shippingInterval: PropTypes.string,
			currencySymbol: PropTypes.string,
		})),
		isDesktop: PropTypes.bool,
		storeSoldOut: PropTypes.bool,
	}
}

export default VipCollection;
